import styled from "styled-components";
export const StepList = styled.ol `
  list-style-type: none;
  padding: 0;
  @media (min-width: 1070px) {
    position: sticky;
    top: 0;
  }
`;
//# sourceMappingURL=styled.js.map